<div class="spinner">
  &nbsp;
</div>
